var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-624 -2169)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3020",
    "data-name": "Group 3020",
    transform: "translate(623.977 2168.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_782",
    "data-name": "Rectangle 782",
    d: "M5,1A4,4,0,0,0,1,5V31a4,4,0,0,0,4,4H31a4,4,0,0,0,4-4V5a4,4,0,0,0-4-4H5M5,0H31a5,5,0,0,1,5,5V31a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(0.024 0.055)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(631.5 2174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M10.674,5.25A10.1,10.1,0,0,1,18,8.823a16.476,16.476,0,0,1,2.521,3.514.75.75,0,0,1,0,.671A16.476,16.476,0,0,1,18,16.521a10.1,10.1,0,0,1-7.323,3.573,10.1,10.1,0,0,1-7.323-3.573A16.476,16.476,0,0,1,.829,13.007a.75.75,0,0,1,0-.671A16.476,16.476,0,0,1,3.351,8.823,10.1,10.1,0,0,1,10.674,5.25Zm8.319,7.422a15.718,15.718,0,0,0-2.116-2.851,8.525,8.525,0,0,0-6.2-3.071c-4.59,0-7.572,4.623-8.319,5.922a15.718,15.718,0,0,0,2.116,2.851,8.525,8.525,0,0,0,6.2,3.071C15.264,18.594,18.246,13.971,18.993,12.672Z",
    fill: "#c7c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M16,12.75A3.252,3.252,0,1,1,12.75,16,3.256,3.256,0,0,1,16,12.75Zm0,5A1.752,1.752,0,1,0,14.25,16,1.754,1.754,0,0,0,16,17.754Z",
    transform: "translate(-5.328 -3.33)",
    fill: "#c7c4c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.90911112870ed25a3d1cb3640efe48a8.svg";
export { ForwardRef as ReactComponent };